export class ToggleItem {
    label: string;
    automationId: string;
    isChecked = false;
    isCollapsed: boolean;
    isDisabled = false;
    width: number;
    tooltip = '';
    data?: any;

    constructor(value?: Partial<ToggleItem>) {
        if (value) {
            Object.assign(this, value);
            if (this.label) {
                this.automationId = `-${this.label.replace(/[^a-zA-Z0-9-_ ]/gi, '').replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase()}`;
            }
        }
    }
}
